import React from 'react';
import { useIntercom } from 'react-use-intercom';
import analytics from '../../../../utils/analytics';
import { PlrTextLink } from './ui';

// Link "Habla con un ejecutivo" del rediseño: abre Intercom igual que AgentContactButton
// (mismo evento 'Contactar Agente'), pero como link de texto en vez de botón.
export default function AgentLink({ cta = 'form bancame', children, testId }: {
  cta?: string,
  children?: React.ReactNode,
  testId?: string,
}) {
  const { show } = useIntercom();
  const handleClick = () => {
    analytics.track('Contactar Agente', { cta, initiator: 'usuario' });
    show();
  };
  return (
    <PlrTextLink onClick={handleClick} testId={testId}>
      {children || 'Habla con un ejecutivo'}
    </PlrTextLink>
  );
}

AgentLink.defaultProps = { cta: 'form bancame', children: undefined, testId: undefined };
